var map = {
	"./01.jpg": "d66c",
	"./010.jpg": "c293",
	"./011.jpg": "acfd",
	"./012.jpg": "7f33",
	"./013.jpg": "d661",
	"./014.jpg": "800a",
	"./015.jpg": "009f",
	"./016.jpg": "c324",
	"./02.jpg": "df40",
	"./03.jpg": "64d5",
	"./04.jpg": "ed64",
	"./05.jpg": "d71c",
	"./06.jpg": "61d8",
	"./07.jpg": "db85",
	"./08.jpg": "17c0",
	"./09.jpg": "1d03",
	"./default-skin.png": "6bfb",
	"./default-skin.svg": "0c00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfee";